import AreaFilter from '../location/area/AreaFilter.vue';
import LocationV2Filter from './LocationV2Filter.class';
import DropdownFilter from '../dropdown-filter-enhanced/DropdownFilter.vue';
import CountryCheckbox from '../checkbox/country-checkbox/CountryCheckbox.vue';
import Checkbox from '../checkbox/Checkbox.vue';
import { Component, defineComponent, provide } from 'vue';
import { IFilterProvider } from '@/interfaces/filter-providers/IFilterProvider';
import { FilterProviderKey } from '@/platform/FilterProviderKey';
import { InjectExternal } from '../../platform/InjectExternal';
import { ILocationFilterProvider } from '@/interfaces/filter-providers/ILocationFilterProvider';
import { CountryFilterSelection } from '../location/country/CountryFilterSelection';
import { CountryFilterContext } from '../location/country/CountryFilterContext';
import { CountryExpandability } from '../location/country/CountryExpandability';
import { FilterKey } from '@/models/FilterKey';

export default defineComponent({
	components: {
		DropdownFilter: DropdownFilter as Component,
		CountryCheckbox: CountryCheckbox as Component,
		AreaFilter: AreaFilter as Component,
		Checkbox: Checkbox as Component,
	},
	setup: () => {
		const filterProvider = InjectExternal<IFilterProvider>(FilterProviderKey.FILTER_PROVIDER);
		const locationFilterProvider = InjectExternal<ILocationFilterProvider>(FilterProviderKey.LOCATION_FILTER_PROVIDER);
		const component = new LocationV2Filter(filterProvider, locationFilterProvider);

		const countryFilterSelection = new CountryFilterSelection(filterProvider, locationFilterProvider);
		const context = new CountryFilterContext(filterProvider, locationFilterProvider, new CountryExpandability(), countryFilterSelection);

		provide(CountryFilterContext.key, context);

		return {
			key: component.key,
			selectionName: component.selectionName,
			lastValidSelectionOption: component.lastValidSelectionOption,
			filterHintCount: component.filterHintCount,
			collapsed: component.collapsed,
			popularCountries: component.popularCountries.value,
			selectedCountries: component.selectedLocations.countries,
			selectedContinents: component.selectedLocations.continents,
			continentFilterKey: FilterKey.CONTINENT,
			processSelection: component.processSelection.bind(component),
			suggest: component.suggest.bind(component),
			toggleFilter: component.toggleFilter.bind(component),
			processAreaFilterChange: component.processAreaFilterChange.bind(component),
			processCountryCheckboxSelection: component.processCountryCheckboxSelection.bind(component),
		};
	},
});
